import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFashioninline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M32 59V43m0-38h2.75c-.458 2.923 0 4.385 1.375 4.385 2.063 0 6.875.73 6.875 4.384 0 3.654-4.125 6.32-4.125 11.693 0 5.373 3.438 7.307 3.438 12.423 0 3.41-1.146 5.115-3.438 5.115h-13.75c-2.292 0-3.438-1.705-3.438-5.115 0-5.116 3.438-7.05 3.438-12.423 0-5.374-4.125-8.039-4.125-11.693s4.813-4.384 6.875-4.384c1.375 0 1.833-1.462 1.375-4.385H32zM22 59h20",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgFashioninline;
